import styled from 'styled-components';

export const DivMain = styled.div`
    background-color: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: start;
    height: inherit;
    padding: 10px 0 0 0;
    overflow:hidden auto;
    >img{
        margin:0 0 20px 0;
    }
`;
